import { Component, OnInit, inject, signal } from '@angular/core';

import { RouterOutlet, Router, ResolveEnd } from '@angular/router';
import { NavbarComponent } from './components/layout/navbar-v2/navbar-v2.component';
import { FooterComponent } from './components/layout/footer-v2/footer-v2.component';
import { AnalyticsService } from './services/analytics.service';
import { ThemeService } from './services/theme.service';
import { filter } from 'rxjs/operators';
import { isShellHidden } from './core/shell';
import { BrandSwitcherComponent } from './components/shared/brand-switcher/brand-switcher.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NavbarComponent, FooterComponent, BrandSwitcherComponent],
  templateUrl: './app.component.html',
  styles: ``,
})
export class AppComponent implements OnInit {
  private themeService = inject(ThemeService);
  private router = inject(Router);
  /** Ensures {@link AnalyticsService} is constructed so GA4 page_view tracking runs. */
  private readonly _analytics = inject(AnalyticsService);
  /** null until the first route resolves, so neither shell variant flashes on load. */
  readonly shellHidden = signal<boolean | null>(null);

  ngOnInit() {
    this.loadGeistFont();
    this.router.events
      .pipe(filter((e): e is ResolveEnd => e instanceof ResolveEnd))
      .subscribe((e) => {
        this.shellHidden.set(isShellHidden(e.urlAfterRedirects, e.state.root));
      });
  }

  private loadGeistFont() {
    if (typeof document !== 'undefined') {
      const existingLink = document.getElementById('geist-font-link');
      if (!existingLink) {
        const link = document.createElement('link');
        link.id = 'geist-font-link';
        link.rel = 'stylesheet';
        link.href =
          'https://fonts.googleapis.com/css2?family=Geist:wght@300;400;500;600;700&display=swap';
        document.head.appendChild(link);
      }
    }
  }
}
